import { render, staticRenderFns } from "./contact_centers.vue?vue&type=template&id=5db51318&scoped=true&"
import script from "./contact_centers.vue?vue&type=script&lang=js&"
export * from "./contact_centers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db51318",
  null
  
)

export default component.exports